module.exports = __webpack_public_path__ + "img/bind-back-1.4a5d047.png";